import { Check, Shield } from 'lucide-react';

import type { RegionOption } from './regionAccessOptions';

interface RowProps {
  option: RegionOption;
  checked: boolean;
  locked: boolean;
  onToggle: (id: string) => void;
}

export default function RegionAccessRow({ option, checked, locked, onToggle }: RowProps) {
  return (
    <button
      type="button"
      onClick={() => !locked && onToggle(option.id)}
      disabled={locked}
      aria-pressed={checked}
      className={`flex items-start gap-2 w-full px-2.5 py-1.5 rounded-md border text-left transition ${
        checked
          ? 'bg-white dark:bg-[#1a1f1c] border-stone-200 dark:border-stone-700'
          : 'border-transparent hover:bg-white/60 dark:hover:bg-[#242d28]/60'
      } ${locked ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <span
        className={`w-4 h-4 mt-0.5 rounded border-[1.5px] flex items-center justify-center flex-none ${
          checked
            ? 'bg-moss-600 border-moss-600 text-white'
            : 'border-stone-300 dark:border-stone-600 bg-white dark:bg-[#0f1311]'
        }`}
      >
        {checked && <Check size={11} strokeWidth={3} />}
      </span>
      <span className="flex-1 min-w-0">
        <span
          className={`block text-[12.5px] font-medium ${
            locked ? 'text-stone-500 dark:text-stone-500' : 'text-bark-900 dark:text-[#e8ece9]'
          }`}
        >
          {option.name}
        </span>
        {option.covers.length > 0 && (
          <span className="block text-[11px] text-stone-500 dark:text-stone-400 truncate">
            Covers {option.covers.join(', ')}
          </span>
        )}
      </span>
      {locked && <Shield size={11} className="mt-1 flex-none" />}
    </button>
  );
}
